export default {
	// apiUrl: "http://127.0.0.1:8000",
	// apiUrl: "http://cleanfi-staging.us-west-1.elasticbeanstalk.com/",
	apiUrl: 'https://api.cleanfi.com',
	mapboxToken:
		'pk.eyJ1IjoicGFjZWZpIiwiYSI6ImNrZ3Y0YjRmaTA1Y3oyc24yZ3JrYjJrcGUifQ.eUHHalTGNyAUgqmoU4Hn9g',
	googleAuthClientId:
		'176588459439-c9e25sfrskgr57b83380bjahq8kbj0lp.apps.googleusercontent.com',
	linkedinAuthClientId: '77dukb0c7kzthd',
	linkedinAuthRedirectURI: '',
	squareProdAppId: 'sq0idp-WWKygNaOGknOO8YSs8CCuA',
	squareSandboxAppId: 'sandbox-sq0idb-EvgWbdAwmLfoK160vog-Yw',
};
